import { Button, Input, Modal, Select, Form } from 'antd';
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from '@hooks/redux';
import { sendFeedbackApi } from '@http/user';
import openNotification from '@utils/openNotification';

interface ReviewProps {
  modalOpen: boolean;
  onModalClose: () => void;
}

const Review = ({ modalOpen, onModalClose }: ReviewProps) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const dispatch = useAppDispatch();

  const handleFinish = (values: any) => {
    dispatch(sendFeedbackApi(values)).then((data: any) => {
      if (data) {
        onModalClose();
        form.resetFields();
        openNotification('success', {
          description: t('Thank you for your feedback'),
        });
      }
    });
  };

  return (
    <Modal width={500} open={modalOpen} onOk={onModalClose} onCancel={onModalClose} footer={null}>
      <Form onFinish={handleFinish} form={form}>
        <p className='text-lg mb-5 font-semibold'>{t('Leave a review')}</p>
        <Form.Item
          name='feedback_type'
          className='w-full mb-0'
          rules={[{ required: true, message: `${t('Required')}` }]}
        >
          <Select allowClear size='large' placeholder={`${t('Type of request')}`} className='mb-5 w-full'>
            <Select.Option value='review'>{t('Review')}</Select.Option>
            <Select.Option value='offer'>{t('Suggestion')}</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item name='text' className='w-full mb-0' rules={[{ required: true, message: `${t('Required')}` }]}>
          <Input.TextArea placeholder={`${t('Message')}`} rows={4} />
        </Form.Item>
        <div className='mt-5 flex justify-end'>
          <Button type='primary' size='large' htmlType='submit'>
            {t('Send')}
          </Button>
        </div>
      </Form>
    </Modal>
  );
};

export default Review;
